import React from "react";
import { Link } from 'react-router-dom';
import Hugo from "../../img/Hugo.PNG";
import './Staff.css';

const Staff = () => {
    return (
        <section id="staff" className="s_about">
            <figure className="img_about">
                <img src={Hugo} alt="Mestre Hugo Matos" className="hugo" loading="lazy" />
                <figcaption className="img-caption">Mestre Hugo Matos</figcaption>
            </figure>
            <div className="text_about">
                <span className="staff-label">Treinadores</span>
                <h2 className="staff-heading">Hugo Matos</h2>
                <div className="staff-divider" aria-hidden="true"></div>
                <p className="p_about">
                    Possui todas as capacidades técnicas e psicológicas que fazem dele um dos melhores treinadores da atualidade.
                    Detém o grau de 3.º Dan de Kickboxing e o grau de 1.º Dan de Taekwondo.
                    Tem todas as qualidades desportivas e humanas para fazer de qualquer aluno um verdadeiro campeão.
                </p>
                <p className="p_about motto">O seu lema: <em>“Parar é morrer!”</em></p>
                <Link to="/About_staff" className="btn-secondary b_about">Ler a biografia completa</Link>
            </div>
        </section>
    );
}

export default Staff;
